import axios from "../../../axios";

export function fetchProfileData() {
  const response = axios.get(`/accounts/profile/`);
  return response;
}
export function updateProfileData(payload: any) {
  const response = axios.put(`/accounts/profile/`, payload);
  return response;
}
export function emailVerification() {
  const response = axios.post(`/accounts/send-verification-email/`);
  return response;
}
